/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react-hooks/exhaustive-deps */
import MultiSelectInputFreeSolo from '@brands/Components/Inputs/MuiMultiSelectInputFreeSolo/MultiSelectInputFreeSolo';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import { medicalConditionQuestions } from '@brands/Dashboard/MedicalHistory/MedicalCondition/utils/questions';
import { useWindowSize } from '@brands/hooks';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useSnackbar } from '@brands/hooks/useStackbar';
import { sanitizeMedicalHistoryBooleans } from '@brands/Dashboard/PatientForms/PatientForm/ClinicalData/utils/medicalHistoryDefaults';
import { useMedicalHistoryOptional } from '@brands/Dashboard/PatientForms/PatientForm/utils/clinicalEnablementFlow';
import { addClinicalData } from '@brands/services/clinical_data/addClinicalData';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import { updateClinicalData } from '@brands/services/clinical_data/updateClinicalData';
import { getUserById } from '@brands/services/identity/getUserById';
import { UserProfile, UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setExternalForms } from '@brands/store/slices/patientFormSlice';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import GenericSnackbar from '@brands/Utils/GenericSnackbar';
import { DEFAULT_PATIENT_LOCATION_STATE } from '@brands/Utils/localStorage';
import { yupResolver } from '@hookform/resolvers/yup';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';
import { isEqual } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import Container from '../../../Components/Container/Container';
import TextField from '../../../Components/Inputs/MuiTextField/TextField';
import MuiToggle from '../../../Components/Inputs/MuiToggle/MuiToggle';
import QuestionAndRadioButton from '../../../Components/QuestionAndAnswers/QuestionAndRadioButtonForMed/QuestionAndRadioButton';
import { useAppDispatch, useAppSelector } from '../../../hooks/useReduxHook';
import { displayErrorDetails } from '../../../Utils/displayError';
import { MedicalConditionSubmit } from '../MedicalCondition/utils/types';
import styles from './styles.module.scss';
import {
  allergyAndMedicationOptions,
  MedicalConditionDefault,
  MedicalHistoryDefault,
  medicationOptions,
  useFollowingQuestions,
} from './utils/questions';
import { MedicalHistoryProps, MedicalHistorySubmit } from './utils/types';
import { combinedValidationSchema, profileCombinedValidationSchema } from './utils/validationSchema';

type MedicalHistory = {
  id: number;
  under_care_of_physician: boolean;
  conditions_treated: string | null;
  taking_medication: boolean;
  medications: string | null;
  allergic_to_medications: boolean;
  medications_allergies: string | null;
  using_substances: string[];
  interested_in_stopping: boolean | null;
  height: string;
  weight: string;
  height_cm?: number | null;
  weight_kg?: number | null;
  height_unit?: string;
  weight_unit?: string;
  pharmacy_name: string | null;
  pharmacy_street_address: string | null;
  pharmacy_city: string | null;
  pharmacy_state: string | null;
  pharmacy_zip_code: string | null;
  pharmacy_phone_number: string | null;
};

const MedicalHistory = ({ isProfileCard, formRef, setIsDirty }: MedicalHistoryProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { state, pathname } = useLocation();
  const roleNavigate = useRoleNavigate();
  const screenSize = useWindowSize();
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const bypassRequired = useMedicalHistoryOptional(values);
  const { userInfo } = useAppSelector(selectAuth);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const currentState = useAppSelector(selectCurrentPatientState);
  const selectedPatientId = selectedPatient?.value;
  const selectedPatientNumberId = Number(selectedPatientId);
  const normalizedSelectedPatientId =
    selectedPatientId !== undefined && selectedPatientId !== '' && Number.isFinite(selectedPatientNumberId)
      ? selectedPatientNumberId
      : undefined;
  const statePatientNumberId = Number(state?.patientId);
  const normalizedStatePatientId =
    state?.patientId !== undefined && state?.patientId !== '' && Number.isFinite(statePatientNumberId)
      ? statePatientNumberId
      : undefined;
  const currentPatientId = currentPatient?.id;
  const currentPatientGuardianId = currentPatient?.guardian_id;
  const userRoleName = userInfo.role.name;
  const isStaffActingForPatient =
    userRoleName === UserRoleName.Admin ||
    userRoleName === UserRoleName.SuperAdmin ||
    userRoleName === UserRoleName.OrganizationAdmin ||
    userRoleName === UserRoleName.Collector ||
    userRoleName === UserRoleName.CareAdvisor;
  const activePatientState = isStaffActingForPatient
    ? (currentPatientId ? currentState[currentPatientId] : '') ||
      (normalizedSelectedPatientId ? currentState[normalizedSelectedPatientId] : '') ||
      (normalizedStatePatientId ? currentState[normalizedStatePatientId] : '') ||
      state?.patientState ||
      currentPatient?.address?.state ||
      DEFAULT_PATIENT_LOCATION_STATE
    : currentState[userInfo.id] || state?.patientState || userInfo.address?.state || DEFAULT_PATIENT_LOCATION_STATE;
  const isAdminUserRole = userRoleName === UserRoleName.SuperAdmin || userRoleName === UserRoleName.OrganizationAdmin;
  const shouldHydrateWithLoader = pathname.includes('clinical-data/recap') || Boolean(state?.isIntakeProcess);
  const [historyObjectId, setHistoryObjectId] = useState<number | null>(null);
  const [conditionsObjectId, setConditionsObjectId] = useState<number | null>(null);
  const { snackbar, showSnackbar, closeSnackbar } = useSnackbar();
  const [guardianPatient, setGuardianPatient] = useState<UserProfile>();
  const [loading, setLoading] = useState(shouldHydrateWithLoader);
  const [initialValues, setInitialValues] = useState<CombinedForm>();
  const [isDisabled, setIsDisabled] = useState(false);
  const [savedConditionsTreated, setSavedConditionsTreated] = useState('');
  const [savedMedications, setSavedMedications] = useState('');
  const [savedMedAllergies, setSavedMedAllergies] = useState('');
  const [selectedPatientMedicalHistory, setSelectedPatientMedicalHistory] = useState<MedicalHistory>();
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const isIntakeProcess = useMemo(() => {
    return state?.isIntakeProcess || pathname.includes('clinical-data/recap') || false;
  }, [state]);

  const [formCache, setFormCache] = useState<Partial<CombinedForm>>({});

  const resolveCurrentUserId = (guardian?: UserProfile): number | undefined => {
    if (isAdminUserRole) {
      if (currentPatientGuardianId != null) {
        return Number(guardian?.id ?? currentPatientGuardianId);
      }
      return currentPatientId ?? normalizedSelectedPatientId ?? normalizedStatePatientId;
    }

    return currentPatientId ?? normalizedSelectedPatientId ?? normalizedStatePatientId ?? userInfo.id;
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors, isValid },
    getValues,
    reset,
    control,
  } = useForm<CombinedForm>({
    mode: 'onChange',
    resolver: yupResolver(isIntakeProcess ? combinedValidationSchema : profileCombinedValidationSchema),
    defaultValues: {
      ...MedicalConditionDefault,
      ...MedicalHistoryDefault,
      ...formCache,
    },
  });

  const watchedValues = useWatch({
    control,
  });

  const saveFormData = useCallback((): void => {
    if (hasUnsavedChanges && !loading) {
      const currentValues = getValues();
      sessionStorage.setItem('medicalHistoryData', JSON.stringify(currentValues));
    }
  }, [hasUnsavedChanges, loading, getValues]);

  const checkExternalForms = async (): Promise<void> => {
    const fetchedGuardian = guardianPatient ?? (await getGuardianPatient());
    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(
        isAdminUserRole ? fetchedGuardian ?? (currentPatient as UserProfile | null) ?? userInfo : userInfo,
        currentPatient ?? null,
      );
    const formsToSet = [];

    if (!checkProfile) {
      formsToSet.push('patient_profile');
    }
    if (!checkMedicalHistory) {
      formsToSet.push('patient_medical_history');
    }
    if (!checkMedicalConditionsFormAnswer) {
      formsToSet.push('patient_medical_conditions');
    }
    if (!checkDentalHistoryFormAnswer) {
      formsToSet.push('patient_dental_history');
    }

    dispatch(setExternalForms(formsToSet));
  };

  const onSubmit = async (data: CombinedForm): Promise<void> => {
    try {
      setLoading(true);
      setHasUnsavedChanges(false);
      const currentUserId = resolveCurrentUserId(guardianPatient);
      if (!currentUserId) {
        setLoading(false);
        toast.error('Patient information is missing. Please select a patient and try again.');
        return;
      }

      const height = `${data.height_feet || 0}ft, ${data.height_inches || 0}in`;
      const weight = `${data.weight || 0}lb`;
      const using_substances = [
        data.tobacco_products ? 'Tobacco Products' : null,
        data.recreational_drugs ? 'Recreational Drugs' : null,
        data.prescription_medication_for_non_medical_reasons ? 'Prescription medication for non-medical reasons' : null,
      ].filter(Boolean) as string[];

      const {
        arthritis,
        cancer,
        dementia_alzheimers,
        diabetes,
        heart_disease,
        dry_mouth,
        obesity,
        pregnancy_or_breastfeeding,
        respiratory_conditions,
        stroke,
        conditions_not_listed,
        medical_condition_none_of_the_above,
        ...rest
      } = data;

      const filteredRest = Object.fromEntries(
        Object.entries(rest).filter(
          ([key]) =>
            ![
              'height_feet',
              'height_inches',
              'tobacco_products',
              'recreational_drugs',
              'prescription_medication_for_non_medical_reasons',
            ].includes(key),
        ),
      );

      const {
        id,
        height_cm,
        height_unit,
        pharmacy_city,
        pharmacy_name,
        pharmacy_phone_number,
        pharmacy_state,
        pharmacy_street_address,
        pharmacy_zip_code,
        weight_kg,
        weight_unit,
      } = selectedPatientMedicalHistory || {};

      const medicalHistoryPayload: MedicalHistorySubmit = {
        ...MedicalHistoryDefault,
        ...filteredRest,
        user_id: currentUserId,
        height,
        weight,
        using_substances,
        medications: data.taking_medication ? data.medications : '',
        medications_allergies: data.allergic_to_medications ? data.medications_allergies : '',
        conditions_treated: data.under_care_of_physician ? data.conditions_treated : '',
        ...(id && { id }),
        ...(height_cm && { height_cm }),
        ...(height_unit && { height_unit }),
        ...(pharmacy_city && { pharmacy_city }),
        ...(pharmacy_name && { pharmacy_name }),
        ...(pharmacy_phone_number && { pharmacy_phone_number }),
        ...(pharmacy_state && { pharmacy_state }),
        ...(pharmacy_street_address && { pharmacy_street_address }),
        ...(pharmacy_zip_code && { pharmacy_zip_code }),
      };

      const medicalConditionPayload: MedicalConditionSubmit = {
        user_id: currentUserId,
        arthritis,
        cancer,
        dementia_alzheimers,
        diabetes,
        heart_disease,
        dry_mouth,
        obesity,
        pregnancy_or_breastfeeding,
        respiratory_conditions,
        stroke,
        conditions_not_listed: conditions_not_listed === 'false' ? '' : conditions_not_listed,
        none_of_the_above: medical_condition_none_of_the_above,
      };

      const sanitizedMedicalHistoryPayload = sanitizeMedicalHistoryBooleans(medicalHistoryPayload);
      if (!historyObjectId) {
        await addClinicalData('medical_history', sanitizedMedicalHistoryPayload);
      } else {
        await updateClinicalData('medical_history', historyObjectId.toString(), sanitizedMedicalHistoryPayload);
      }

      if (!conditionsObjectId) {
        await addClinicalData('medical_conditions', medicalConditionPayload);
      } else {
        await updateClinicalData('medical_conditions', conditionsObjectId.toString(), medicalConditionPayload);
      }

      await checkExternalForms();
      setInitialValues({
        ...getValues(),
      });
      reset(watch());
      setSavedConditionsTreated('');
      setSavedMedications('');
      setSavedMedAllergies('');
      setLoading(false);
      if (!isIntakeProcess) {
        showSnackbar('Medical history updated successfully', 'success');
      }
      if (isIntakeProcess) {
        roleNavigate('/clinical-data/end-step', {
          state: {
            patientState: activePatientState,
            isIntakeProcess: true,
            patientId: currentUserId,
          },
        });
      }
      sessionStorage.removeItem('medicalHistoryData');
    } catch (error) {
      setHasUnsavedChanges(true);
      displayErrorDetails(error);
    }
  };

  const onInvalid = (e: any): void => {
    const error = Object.values(e)[0] as any;
    if (error) {
      toast.error(error.message as string);
    }
  };

  type CombinedForm = MedicalHistorySubmit & MedicalConditionSubmit;

  const getGuardianPatient = async (): Promise<UserProfile | undefined> => {
    if (isAdminUserRole && currentPatientGuardianId != null) {
      const guardianResponse = await getUserById(currentPatientGuardianId as number);
      setGuardianPatient(guardianResponse);
      return guardianResponse;
    }
  };
  const resetStorageForAdmin = async (): Promise<void> => {
    if (isAdminUserRole) {
      sessionStorage.removeItem('medicalHistoryData');
    }
  };

  useEffect(() => {
    let isActive = true;

    const hydrateMedicalHistory = async (): Promise<void> => {
      const fetchedGuardian = await getGuardianPatient();
      const currentUserId = resolveCurrentUserId(fetchedGuardian);

      if (!currentUserId) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        await resetStorageForAdmin();
        const savedDraft = sessionStorage.getItem('medicalHistoryData');
        if (savedDraft) {
          const parsedDraft = JSON.parse(savedDraft);
          if (isActive) {
            reset(parsedDraft);
            setInitialValues(parsedDraft);
          }
        } else {
          const res = await listClinicalData(currentUserId);

          if (!isActive) return;

          if (res.medical_history) {
            setSelectedPatientMedicalHistory(res.medical_history as MedicalHistory);
            setHistoryObjectId(res.medical_history.id || null);
            if (res.medical_history?.height) {
              const [feetPart, inchPart] = res.medical_history.height.split(',');
              const feet = feetPart?.replace('ft', '').trim();
              const inches = inchPart?.replace('in', '').trim();
              setValue('height', res.medical_history.height, { shouldValidate: true });
              setValue('height_feet', feet, { shouldValidate: true });
              setValue('height_inches', inches, { shouldValidate: true });
            }
            if (res.medical_history?.weight) {
              setValue('weight', res.medical_history.weight.split('lb')[0].trim(), { shouldValidate: true });
            }
            setValue('taking_medication', res.medical_history.taking_medication, { shouldValidate: true });
            setValue('medications', res.medical_history.medications, { shouldValidate: true });
            setValue('allergic_to_medications', res.medical_history.allergic_to_medications, { shouldValidate: true });
            setValue('medications_allergies', res.medical_history.medications_allergies, { shouldValidate: true });
            setValue('under_care_of_physician', res.medical_history.under_care_of_physician, { shouldValidate: true });
            setValue('conditions_treated', res.medical_history.conditions_treated, { shouldValidate: true });
            if (res.medical_history.using_substances) {
              const substances = res.medical_history.using_substances as string[];

              setValue('tobacco_products', substances.includes('Tobacco Products'), { shouldValidate: true });
              setValue('recreational_drugs', substances.includes('Recreational Drugs'), { shouldValidate: true });
              setValue(
                'prescription_medication_for_non_medical_reasons',
                substances.includes('Prescription medication for non-medical reasons'),
                { shouldValidate: true },
              );
            }
            setValue('interested_in_stopping', res.medical_history.interested_in_stopping, { shouldValidate: true });
          }
          if (res.medical_conditions) {
            setConditionsObjectId(res.medical_conditions.id || null);
            setValue('arthritis', res.medical_conditions.arthritis || false, { shouldValidate: true });
            setValue('cancer', res.medical_conditions.cancer || false, { shouldValidate: true });
            setValue('dementia_alzheimers', res.medical_conditions.dementia_alzheimers || false, {
              shouldValidate: true,
            });
            setValue('diabetes', res.medical_conditions.diabetes || false, { shouldValidate: true });
            setValue('heart_disease', res.medical_conditions.heart_disease || false, { shouldValidate: true });
            setValue('dry_mouth', res.medical_conditions.dry_mouth || false, { shouldValidate: true });
            setValue('obesity', res.medical_conditions.obesity || false, { shouldValidate: true });
            setValue('pregnancy_or_breastfeeding', res.medical_conditions.pregnancy_or_breastfeeding || false, {
              shouldValidate: true,
            });
            setValue('respiratory_conditions', res.medical_conditions.respiratory_conditions || false, {
              shouldValidate: true,
            });
            setValue('stroke', res.medical_conditions.stroke || false, { shouldValidate: true });
            setValue(
              'conditions_not_listed',
              res.medical_conditions.conditions_not_listed === 'true'
                ? ''
                : res.medical_conditions.conditions_not_listed || '',
              { shouldValidate: true },
            );
            setValue('medical_condition_none_of_the_above', res.medical_conditions.none_of_the_above || false, {
              shouldValidate: true,
            });
          }
          setInitialValues({
            ...getValues(),
          });
          if (Object.keys(formCache).length > 0) {
            // Restore form values from cache
            Object.entries(formCache).forEach(([key, value]) => {
              setValue(key as keyof CombinedForm, value, { shouldValidate: true });
            });
          }
        }
      } catch (error) {
        if (isActive) {
          displayErrorDetails(error);
        }
      } finally {
        if (isActive) {
          setLoading(false);
          setHasUnsavedChanges(false);
        }
      }
    };

    hydrateMedicalHistory();

    return () => {
      isActive = false;
    };
  }, [selectedPatientId, currentPatientId, currentPatientGuardianId, userRoleName, state?.patientId, userInfo.id]);

  useEffect(() => {
    return () => {
      saveFormData();
    };
  }, [saveFormData]);

  useEffect(() => {
    // Handle page refresh/close
    const handleBeforeUnload = (): void => {
      saveFormData();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [saveFormData]);

  useEffect(() => {
    if (!initialValues) return;

    // Remove derived values to avoid false-positive dirty states
    const normalizedCurrent = {
      ...watchedValues,
      height: `${watchedValues.height_feet || 0}ft, ${watchedValues.height_inches || 0}in`,
    };

    const normalizedInitial = {
      ...initialValues,
      height: `${initialValues.height_feet || 0}ft, ${initialValues.height_inches || 0}in`,
    };

    const changed = !isEqual(normalizedCurrent, normalizedInitial);

    setIsDirty?.(changed);
    setIsDisabled(changed && isValid);
  }, [watchedValues, initialValues, isValid]);

  useEffect(() => {
    const allFalse = useFollowingQuestions?.every((item) => !watch(item.id as keyof CombinedForm));
    if (allFalse) {
      setValue('interested_in_stopping', null, { shouldValidate: true });
    }
  }, [
    watch('tobacco_products'),
    watch('recreational_drugs'),
    watch('prescription_medication_for_non_medical_reasons'),
  ]);

  useEffect(() => {
    const noneOfTheAbove = watch('medical_condition_none_of_the_above');
    if (noneOfTheAbove) {
      setValue('arthritis', false, { shouldValidate: true });
      setValue('cancer', false, { shouldValidate: true });
      setValue('dementia_alzheimers', false, { shouldValidate: true });
      setValue('diabetes', false, { shouldValidate: true });
      setValue('heart_disease', false, { shouldValidate: true });
      setValue('dry_mouth', false, { shouldValidate: true });
      setValue('obesity', false, { shouldValidate: true });
      setValue('pregnancy_or_breastfeeding', false, { shouldValidate: true });
      setValue('respiratory_conditions', false, { shouldValidate: true });
      setValue('stroke', false, { shouldValidate: true });
      setValue('conditions_not_listed', '', { shouldValidate: true });
    }
  }, [watch('medical_condition_none_of_the_above')]);

  if (loading) {
    return <Loading dotted />;
  }
  const MedicalHistoryComponent = (
    <div className={styles.ProfileContainer}>
      <div className={`${styles.ProfileDiv} ${styles.medicalContainer}`}>
        {isIntakeProcess && <PatientIntakeNavigation progress={20} />}
        <form
          ref={formRef}
          className={styles.formContainer}
          style={{
            width: true ? '100%' : '',
            marginRight: true ? '0px' : '',
            borderTop: isIntakeProcess ? '1px solid var(--divider, rgba(23, 36, 51, 0.12))' : '',
          }}
          onSubmit={handleSubmit(onSubmit, onInvalid)}
        >
          <div className={styles.wrapper} style={{ maxWidth: isIntakeProcess ? '798px' : '654px' }}>
            <div
              className={`${styles.formQuestion} fs-unmask`}
              style={{ paddingBottom: '16px', paddingTop: isIntakeProcess ? '32px' : '' }}
            >
              Do you have, or have you had, any of the following medical conditions?
            </div>
            <div className={styles.formSection} style={{ paddingTop: '0px' }}>
              <div className={styles.formContent}>
                {[...medicalConditionQuestions].map((element) => (
                  <QuestionAndRadioButton<CombinedForm>
                    data-testid="medical-history-medical-condition"
                    key={element.id}
                    element={element}
                    value={watch(element.id as keyof CombinedForm)}
                    setValue={setValue}
                    trigger={trigger}
                    isMedicalHistory
                  />
                ))}
              </div>
            </div>

            <div className={styles.formSection}>
              <div className={`${styles.formQuestion} fs-unmask`}>
                Are you now, or have you been in the past year, under the care of a physician?
              </div>
              <div className={styles.formContent}>
                <MuiToggle
                  {...register('under_care_of_physician')}
                  label="Are you now, or have you been in the past year, under the care of a physician?"
                  hideLabel
                  data-testid="medical-history-under-care-physician"
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' },
                  ]}
                  selectedValue={
                    watch('under_care_of_physician') === null ? '' : watch('under_care_of_physician') ? 'yes' : 'no'
                  }
                  onChange={(val) => {
                    const isYes = val === 'yes';
                    setValue('under_care_of_physician', isYes, { shouldValidate: true });

                    if (!isYes) {
                      setSavedConditionsTreated(watch('conditions_treated') || '');
                      setValue('conditions_treated', '', { shouldValidate: true });
                    } else {
                      setValue('conditions_treated', savedConditionsTreated, { shouldValidate: true });
                    }
                  }}
                />
              </div>
            </div>

            {watch('under_care_of_physician') && (
              <div className={styles.formSection}>
                <div className={`${styles.formQuestion} fs-unmask`}>
                  What conditions are being treated by your physician?
                </div>
                <div className={styles.formContent}>
                  <TextField
                    {...register('conditions_treated')}
                    hideLabel
                    multiline
                    minRows={4}
                    value={watch('conditions_treated') || ''}
                    label="What conditions are being treated by your physician?"
                    errors={errors.conditions_treated || {}}
                    onChange={(val) => setValue('conditions_treated', val.target.value, { shouldValidate: true })}
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                  />
                </div>
              </div>
            )}

            <div className={styles.formSection}>
              <div>
                <div className={`${styles.formQuestion} fs-unmask`}>Are you taking any medications?</div>
                <div className={styles.formQuestionExplaination}>
                  Within the last month, have you taken (or supposed to be taking) any medications? This includes
                  prescription, over-the-counter, diet supplements, and natural or herbal vitamins.
                </div>
              </div>
              <div className={styles.formContent}>
                <MuiToggle
                  {...register('taking_medication')}
                  label="Are you taking any medications?"
                  hideLabel
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' },
                  ]}
                  selectedValue={watch('taking_medication') === null ? '' : watch('taking_medication') ? 'yes' : 'no'}
                  onChange={(val) => {
                    const isYes = val === 'yes';
                    setValue('taking_medication', isYes, { shouldValidate: true });

                    if (!isYes) {
                      setSavedMedications(watch('medications') || '');
                      setValue('medications', '', { shouldValidate: true });
                    } else {
                      setValue('medications', savedMedications, { shouldValidate: true });
                    }
                  }}
                />
              </div>
              {watch('taking_medication') && (
                <div className={styles.formContent} style={{ gap: '8px' }}>
                  <div style={{ fontSize: '14px' }}>Search medications</div>
                  <MultiSelectInputFreeSolo
                    {...register('medications')}
                    label="Search medications"
                    errors={errors.medications ? errors : {}}
                    name="medications"
                    onChange={(selectedValues: any) => {
                      setValue('medications', selectedValues.join(', '), { shouldValidate: true });
                    }}
                    hideLabel
                    styledTag
                    displayCheckbox={false}
                    value={watch('medications')
                      ?.split(',')
                      .map((med: string) => med.trim())}
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.completeProfileLanguage}`}
                    options={medicationOptions}
                  />
                </div>
              )}
            </div>

            <div className={styles.formSection}>
              <div className={`${styles.formQuestion} fs-unmask`}>
                Are you allergic to any medications, metal, latex, or certain materials?
              </div>
              <div className={styles.formContent}>
                <MuiToggle
                  {...register('allergic_to_medications')}
                  label="Are you allergic?"
                  hideLabel
                  options={[
                    { value: 'yes', label: 'Yes' },
                    { value: 'no', label: 'No' },
                  ]}
                  selectedValue={
                    watch('allergic_to_medications') === null ? '' : watch('allergic_to_medications') ? 'yes' : 'no'
                  }
                  onChange={(val) => {
                    const isYes = val === 'yes';
                    setValue('allergic_to_medications', isYes, { shouldValidate: true });

                    if (!isYes) {
                      setSavedMedAllergies(watch('medications_allergies') || '');
                      setValue('medications_allergies', '', { shouldValidate: true });
                    } else {
                      setValue('medications_allergies', savedMedAllergies, { shouldValidate: true });
                    }
                  }}
                />
              </div>
              {watch('allergic_to_medications') && (
                <div className={styles.formContent} style={{ gap: '8px' }}>
                  <div style={{ fontSize: '14px' }}>Search allergies</div>
                  <MultiSelectInputFreeSolo
                    {...register('medications_allergies')}
                    label="Search allergies"
                    errors={errors.medications_allergies ? errors : {}}
                    name="medications_allergies"
                    onChange={(selectedValues: any) => {
                      setValue('medications_allergies', selectedValues.join(', '), { shouldValidate: true });
                    }}
                    hideLabel
                    styledTag
                    displayCheckbox={false}
                    value={watch('medications_allergies')
                      ?.split(',')
                      .map((med: string) => med.trim())}
                    inputClass={`${styles.profileInputClass} fs-exclude`}
                    wrapperClassName={`fs-unmask ${styles.completeProfileLanguage}`}
                    options={allergyAndMedicationOptions}
                  />
                </div>
              )}
            </div>

            <div className={styles.formSection}>
              <div className={`${styles.formQuestion} fs-unmask`}>Do you use any of the following?</div>
              <div className={styles.formContent}>
                {useFollowingQuestions?.map((element) => {
                  return (
                    <QuestionAndRadioButton<CombinedForm>
                      key={element.id}
                      data-testid=""
                      element={element}
                      value={watch(element.id as keyof CombinedForm)}
                      setValue={setValue}
                      trigger={trigger}
                    />
                  );
                })}
              </div>
            </div>

            {useFollowingQuestions?.some((item) => watch(item.id as keyof CombinedForm)) && (
              <div className={styles.formSection}>
                <div className={`${styles.formQuestion} fs-unmask`}>
                  Are you interested in quitting{' '}
                  {useFollowingQuestions
                    .map((item) => (watch(item.id as keyof CombinedForm) ? item.title.toLowerCase() : ''))
                    .filter(Boolean)
                    .join(', ')}
                  ?
                </div>
                <div className={styles.formContent}>
                  <MuiToggle
                    {...register('interested_in_stopping')}
                    label="Are you interested in quitting [selection]?"
                    hideLabel
                    options={[
                      { value: 'yes', label: 'Yes' },
                      { value: 'no', label: 'No' },
                    ]}
                    selectedValue={
                      watch('interested_in_stopping') === true
                        ? 'yes'
                        : watch('interested_in_stopping') === false
                        ? 'no'
                        : ''
                    }
                    onChange={(val) => {
                      setValue('interested_in_stopping', val === 'yes', { shouldValidate: true });
                      trigger('interested_in_stopping');
                    }}
                  />
                </div>
              </div>
            )}

            <div className={styles.formSection} style={{ borderBottom: 'none' }}>
              <div>
                <div className={`${styles.formQuestion} fs-unmask`}>What is your current height and weight?</div>
                <div className={styles.formQuestionExplaination}>
                  We collect this information to ensure you are getting effective and safe prescriptions.
                </div>
              </div>
              <div className={styles.formContent} style={{ gap: '24px' }}>
                <div className={styles.measurementsForm}>
                  <div className={styles.measurementsFormTitle}>Current height:</div>
                  <div className={styles.measurementsFormInput}>
                    <input
                      {...register('height_feet')}
                      type="number"
                      min={0}
                      max={8}
                      value={watch('height_feet') || ''}
                      data-testid="medical-history-height-feet"
                      onChange={(e) => {
                        let { value } = e.target;
                        if (value.length > 1 && value.startsWith('0')) {
                          value = String(parseInt(value, 10));
                        }
                        setValue('height_feet', value, { shouldValidate: true });
                      }}
                    />
                    ft
                    <input
                      {...register('height_inches')}
                      type="number"
                      min={0}
                      max={11}
                      value={watch('height_inches') || ''}
                      data-testid="medical-history-height-inches"
                      onChange={(e) => {
                        let { value } = e.target;
                        if (value.length > 1 && value.startsWith('0')) {
                          value = String(parseInt(value, 10));
                        }
                        setValue('height_inches', value, { shouldValidate: true });
                      }}
                    />
                    in
                  </div>
                </div>
                <div className={styles.measurementsForm} style={{ width: '132px' }}>
                  <div className={styles.measurementsFormTitle}>Current weight:</div>
                  <div className={styles.measurementsFormInput}>
                    <input
                      {...register('weight')}
                      type="number"
                      min={0}
                      max={1000}
                      value={watch('weight') || ''}
                      data-testid="medical-history-weight"
                      onChange={(e) => {
                        let { value } = e.target;
                        if (value.length > 1 && value.startsWith('0')) {
                          value = String(parseInt(value, 10));
                        }
                        setValue('weight', value, { shouldValidate: true });
                      }}
                    />
                    lbs
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.btnContainer}>
              {isIntakeProcess ? (
                <div
                  style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
                  className={styles.btnMobileContainer}
                >
                  <Button
                    variant="text"
                    data-testid="medical-history-back"
                    className={styles.medicalHistoryFooterBack}
                    onClick={() => roleNavigate(-1)}
                  >
                    <ArrowBackIosNewIcon />
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    data-testid="medical-history-next"
                    className={styles.medicalHistoryFooterNext}
                    type="button"
                    onClick={() => {
                      if (isValid || !bypassRequired) {
                        handleSubmit(onSubmit, onInvalid)();
                      } else {
                        onSubmit(getValues());
                      }
                    }}
                  >
                    Next
                  </Button>
                </div>
              ) : (
                <button
                  type="submit"
                  data-testid="medical-history-save"
                  className={styles.saveButton}
                  disabled={!isDisabled || loading}
                >
                  Save Changes
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
      <GenericSnackbar open={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={closeSnackbar} />
    </div>
  );

  if (isIntakeProcess) {
    return (
      <Container
        isVisibleOnMobile
        containerStyle={{
          justifyContent: screenSize.width >= 564 ? 'center' : 'start',
          overflow: 'hidden',
        }}
        childrenStyle={{
          zIndex: '2',
          paddingTop: screenSize.width > 768 ? '40px' : '16px',
          paddingBottom: screenSize.width <= 768 ? '16px' : '40px',
        }}
        isSidenavVisible={false}
        isIntakeProcess
      >
        {MedicalHistoryComponent}
      </Container>
    );
  }
  return MedicalHistoryComponent;
};
export default MedicalHistory;
